(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kimo-breadwinner-review"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.kr-gallery').forEach(gallery=>{gallery.querySelectorAll('[data-kr-view]').forEach(button=>button.addEventListener('click',()=>{const source=button.querySelector('img'),main=gallery.querySelector('[data-kr-main]');main.src=source.src;main.alt=source.alt;gallery.querySelectorAll('[data-kr-view]').forEach(view=>view.setAttribute('aria-pressed',view===button?'true':'false'))}))});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimo-gift-product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-gift-product]').forEach(root=>{
 const main=root.querySelector('.gift-main-image'),open=root.querySelector('[data-gift-enlarge]'),dialog=root.querySelector('[data-gift-zoom]'),zoom=root.querySelector('[data-gift-zoom-image]');
 const pairMain=root.querySelector('[data-gift-pair-main]'),pairZoom=root.querySelector('[data-gift-pair-zoom]'),caption=root.querySelector('[data-gift-pair-caption]');
 if(pairMain)main.hidden=true;
 root.querySelectorAll('[data-gift-view]').forEach(button=>button.addEventListener('click',()=>{
  if(matchMedia('(max-width:650px)').matches){const paired=button.hasAttribute('data-gift-pair-view');zoom.hidden=paired;if(pairZoom)pairZoom.hidden=!paired;if(!paired){zoom.alt=button.dataset.alt;zoom.src=button.dataset.large;}if(!dialog.open)dialog.showModal();return;}
  const paired=button.hasAttribute('data-gift-pair-view');main.hidden=paired;open.dataset.pair=String(paired);if(pairMain)pairMain.hidden=!paired;if(caption)caption.hidden=!paired;
  if(!paired){if(window.kimoLoadImage){window.kimoLoadImage(main,button.dataset.source,button.dataset.alt,ok=>{if(ok)open.href=button.dataset.large;});}else{const photo=new Image();photo.onload=()=>{main.removeAttribute('srcset');main.src=photo.src;main.alt=button.dataset.alt;open.href=button.dataset.large;};photo.src=button.dataset.source;}}
  root.querySelectorAll('[data-gift-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 }));
 open.addEventListener('click',event=>{if(!dialog.showModal)return;event.preventDefault();const paired=open.dataset.pair==='true';zoom.hidden=paired;if(pairZoom)pairZoom.hidden=!paired;if(!paired){zoom.src=open.href;zoom.alt=main.alt;}dialog.showModal();});
 root.querySelector('[data-gift-close]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimo-origin"] && !Shopify.designMode) return;
  try {
    function initKimoHistory(){
 document.querySelectorAll('.kimo-origin-gallery').forEach(gallery=>{
  if(gallery.dataset.ready)return;
  const dialog=gallery.nextElementSibling;
  if(!dialog||typeof dialog.showModal!=='function')return;
  gallery.dataset.ready='true';
  gallery.querySelectorAll('[data-kimo-history]').forEach(link=>link.addEventListener('click',event=>{
   event.preventDefault();const source=link.querySelector('img');const target=dialog.querySelector('img');
   target.src=link.href;target.alt=source.alt;target.width=source.width;target.height=source.height;dialog.showModal();
  }));
  dialog.querySelector('button').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
 });
}
initKimoHistory();document.addEventListener('shopify:section:load',initKimoHistory);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimo-reset-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-kimo-open-size-guide]');
 if(!button)return;
 const scope=button.closest('.reset-product-layout')||button.closest('dialog');
 const guide=scope?.querySelector('[data-kimo-size-guide]');
 if(!guide)return;
 event.preventDefault();
 guide.open=true;
 guide.scrollIntoView({behavior:'auto',block:'center'});
 guide.querySelector('summary')?.focus();
});
  } catch(e) { console.error(e); }
})();

})();
